<template>
  <div class="home">
    <pageTop></pageTop>

    <swiper
        :options="swiperOption"
        ref="swiper"
        @mouseover.native="swiperMouseover"
        @mouseout.native="swiperMouseout"
    >
      <swiper-slide v-for="(item, index) in imgList" :key="index">
        <img  :src="item.imgSrc" class="bannerImg" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination">
          <span
              v-for="(item, index) in imgList"
              :class="['dot', index == swiper.realIndex?'cur':'']"
              :key="index">
          </span>
      </div>
      <div
          :class="['swiper-button-prev', showArrows?'show': '']"
          slot="button-prev"
          @click="slidePrev"
      >
      </div>
      <div
          :class="['swiper-button-next', showArrows?'show': '']"
          slot="button-next"
          @click="slideNext"
      >
      </div>
    </swiper>
    <div class="row" >
      <div class="col-md-1">
      </div>

    <div class="col-md-3 h-f"  v-for="item in campusList">
      <figure class="effect-jazz">
        <div class="card__2b15F bg-blue__Se1Tv">
          <div class="layout__fL2iB">
            <div class="text__oBYsw title-main__2y7C2">{{ item.title }}</div>
            <div class="text__oBYsw title-sub__1WQgn">{{ item.content }}</div>
            <div class="text__oBYsw">{{ item.recruitRequire }}</div>
          </div>
          <div class="layout__fL2iB right__GwHP7">
            <a class="text__oBYsw"  href="/jobs" rel="noopener noreferrer">一键投递</a>
          </div>
        </div>
      </figure>
    </div>
    </div>
    <!-- 字节生活 -->
    <div class="byteLife content-item-block"  v-for="item in youngList">
      <h1 class="byteLife-title">{{ item.title }}</h1>
      <div class="block-item block-item-one">
        <div class="block-item-column block-item-column-text">
          <h2 class="block-item-column-title">{{ item.childTitle }}</h2>
          <div class="content">
            <div class="content-item">
              <h2 class="content-item-title">{{ item.cultureOneTitle }}</h2>
              <p class="content-item-desc">{{ item.cultureOne }}</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">{{ item.cultureTwoTitle }}</h2>
              <p class="content-item-desc">{{ item.cultureTwo }}</p>
            </div>
            <div class="content-item">
              <h2 class="content-item-title">{{ item.cultureThreeTitle }}</h2>
              <p class="content-item-desc">{{ item.cultureThree }}</p>
            </div>
          </div>
        </div>
        <div class="block-item-column block-item-column-image">
          <img :src="item.lifePicture" alt />
        </div>
      </div>

    </div>

    <!-- 员工故事 -->
    <div class="staffStory content-item-block">
      <h2 class="title">员工故事</h2>
      <ul class="staffStory-list clearfix">
        <router-link
          tag="li"
          :to="`/staff-stories/${item.id}`"
          v-for="item in staffStories"
          :key="item.id"
          class="staffStory-item"
        >
          <div class="avatar">
            <img width="100%" :src="item.avatar" alt srcset />
          </div>
          <div class="text">
            <h2 class="title">{{ item.title }}</h2>
            <div class="desc">{{ item.name }}&nbsp;|&nbsp;{{ item.department }}</div>
            <p class="remark">{{ item.remark }}</p>
          </div>
          <div class="circular-button">→</div>
        </router-link>
      </ul>
    </div>
    <Footer ></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";
import home, {getStaffStories,getYoung,getCampus} from "@/api/home";

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      campusList: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      youngList: [],
      imgList: [
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/b111ab5e1ac818b86f0379a91d6d9e57.jpg' },
        { imgSrc: 'https://juanxiuhe.oss-cn-beijing.aliyuncs.com/df0edc62dda58b0c109dd7a82e31221f.jpg'  }],
        currentPage: 1,
        swiperOption: {//swiper3
      autoplay: false,
          speed: 300,
          loop: true,
          pagination: {
        el: '.swiper-pagination'
      },
      navigation: {
        nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
      }
    },
    swiper: '',
        showArrows: false
    };
  },
  created() {

  },
  methods: {

    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({ name: "jobs", params: { keyword } });
    },
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },
    truncatedString(str){
      return str.split('。')
    },
    swiperMouseover() {
      this.showArrows = true;
    },
    swiperMouseout() {
      this.showArrows = false;
    },
    slidePrev() {
      this.swiper.slidePrev();
    },
    slideNext() {
      this.swiper.slideNext();
    },
  },
  mounted() {
    this.swiper = this.$refs.swiper.swiperInstance;

    const intervalId = setInterval(this.slideNext, 2000);

    home.getStaffStories({orderBy:"createTime"}).then(rs => {
      this.staffStories = rs.data
    })
    home.getYoung({orderBy:"createTime"}).then(rs => {
      this.youngList = rs.data
    })

    home.getCampus({orderBy:"createTime"}).then(rs => {
      this.campusList = rs.data
    })

  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>
.card__2b15F.bg-blue__Se1Tv {
  background-color: #f4bc20;
  background-position: 36px 80px;
  height: 450px;
}

.card__2b15F .text__oBYsw {
  padding: 15px;
  margin-bottom: 65px;
  //font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: white;
}

.card__2b15F .layout__fL2iB.right__GwHP7 a {
  margin-left: 10px;
  padding: 24px 24px;
  border: 2px solid #f5f5f5;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}

.card__2b15F .text__oBYsw.title-main__2y7C2 {
  margin-bottom: 65px;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: white;
}

a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}

.card__2b15F .text__oBYsw.title-sub__1WQgn {
  margin-bottom: 12px;
  margin-top: 22px;
  font-size: 22px;
  font-weight: 500;
  line-height: 27px;
  color: white;
}

.card__2b15F .layout__fL2iB.right__GwHP7 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: end;
  align-items: end;
  -ms-flex: 1;
  flex: 1 1;
  -ms-flex-pack: start;
  justify-content: flex-start;
  color: white;
}
</style>
